// extracted by extract-css-chunks-webpack-plugin
module.exports = {"col_L":"col_L-3c5atSII","wrapper":"wrapper-5834svLV","box":"box-36gvIjZ4"};